<template>
  <v-list-item link @click="toTarget">
    <!-- <v-list-item-action>
      <v-icon>{{icon}}</v-icon>
    </v-list-item-action> -->
    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  methods: {
    toTarget () {
      console.log('nav this.$router', this.$router)
      this.$router.push({
        path: this.to
      }).catch(() => {
        console.log('catch this.$router', this.$router)
      })
      if (this.$router.history.current.query.to) {
        this.$nextTick(() => window.document.querySelector('#' + this.$router.history.current.query.to).scrollIntoView())
      }
    }
  },
  props: {
    icon: {
      default: 'mdi-post',
      type: String
    },
    title: {
      default: 'item',
      type: String
    },
    to: {
      default: '/',
      type: String
    }
  }
}
</script>
